import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, LogOut } from 'lucide-react';
import { Button } from '../components/Button';
import { StatusMarker } from '../components/StatusMarker';
import { usePlatform } from '../contexts/PlatformContext';
import { demoProfiles } from '../data/profiles';
export function ChooseProfile() {
  const {
    authenticated,
    signIn,
    signOut
  } = usePlatform();
  const navigate = useNavigate();
  if (!authenticated) return <Navigate to="/" replace data-id="element-137" data-mp="3i5859067w4vg" />;
  return <div className="flex min-h-screen w-full flex-col bg-[#0f1017] px-6 py-8" data-id="element-138" data-mp="3i69jtemfz9hx">
      <div className="mx-auto flex w-full max-w-4xl items-center justify-between" data-id="element-139" data-mp="3dbdrseh7gm4t">
        <span className="text-2xl font-semibold tracking-tight" data-id="element-140" data-mp="38dkjnfwcdi1w">nawat</span>
        <Button variant="ghost" size="sm" onClick={() => {
        signOut();
        navigate('/');
      }} data-id="element-141" data-mp="9odgeom98l0d">
          <LogOut className="size-4" data-id="element-142" data-mp="1hg8u283dri8f" /> Sign out
        </Button>
      </div>

      <main className="mx-auto flex w-full max-w-2xl flex-1 flex-col justify-center py-12" data-id="element-143" data-mp="1hibulm25stre">
        <p className="font-mono text-xs uppercase tracking-widest text-[#9b8cf0]" data-id="element-144" data-mp="1meiouhl70gti">demo@nawat.ai</p>
        <h1 className="mt-3 text-3xl font-medium tracking-tight md:text-4xl" data-id="element-145" data-mp="17q5t9lq0ozzj">Choose a profile</h1>
        <p className="mt-2 text-muted-foreground" data-id="element-146" data-mp="1cno4jiribrap">Each profile has its own blood results and recommended pack.</p>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-147" data-mp="yru1vhhbty61">
          {demoProfiles.map((p, i) => {
          const initials = p.name.split(' ').map(n => n[0]).join('');
          return <motion.li key={p.email} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: i * 0.08
          }} data-id="element-148" data-mp="oto6liq0zqa5" data-mpi={i}>
                <button onClick={() => {
              signIn(p);
              navigate('/profile');
            }} className="group w-full rounded-2xl border border-white/10 bg-white/[0.02] p-6 text-left transition-colors hover:border-[#9b8cf0]/60 hover:bg-[#9b8cf0]/[0.05] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9b8cf0]" data-id="element-149" data-mp="2o4fjkldtkyt0">
                  <div className="flex items-center justify-between" data-id="element-150" data-mp="27rawtwuvb45q">
                    <span className={`flex size-14 items-center justify-center rounded-full border text-lg font-medium ${p.goal === 'pregnancy' ? 'border-[#9b8cf0]/50 bg-[#9b8cf0]/10 text-[#c4baff]' : 'border-[#8fd3b0]/40 bg-[#8fd3b0]/10 text-[#8fd3b0]'}`} data-id="element-151" data-mp="35dqbyrztnpq4">
                      {initials}
                    </span>
                    <ChevronRight className="size-5 text-muted-foreground transition-transform group-hover:translate-x-0.5" data-id="element-152" data-mp="3o6kkb32xwjld" />
                  </div>
                  <p className="mt-6 text-lg font-medium" data-id="element-153" data-mp="3rn6xkj7qsb7f">{p.name}</p>
                  <p className="text-sm text-muted-foreground" data-id="element-154" data-mp="3vo0l3bh9vnzs">
                    {p.age} · {p.location}
                  </p>
                  <div className="mt-4" data-id="element-155" data-mp="4hfz4662r69m">
                    <StatusMarker goal={p.goal} stage={p.stage} data-id="element-156" data-mp="4gecr5jlyxcl" />
                  </div>
                </button>
              </motion.li>;
        })}
        </ul>
      </main>
    </div>;
}